export default __webpack_public_path__ + "static/media/charm-crystal.e66c831d.gif";